import ShoppingCartPriceData from "../logic/payment/RefreshShoppingCartPrice";
import eventBus from "../../EventBus";

export default {
    data: () => ({}),
    computed: {
        getLanguage: {
            get: function() {
                return this.$store.getters.getLanguage;
            }
        },
        // Computo para obtener todos los albumes agregados al carrito
        getLoading: {
            get: function() {
                return this.$store.getters.getLoading;
            }
        },
        // Computo para obtener todos los albumes agregados al carrito
        getShoppingCart: {
            get: function() {
                
                
                return this.$store.getters.shoppingCart;
            }
        },
        //Computo para obtener el total de albumes agregados al carrito
        shoppingCartCounter: {
            get: function() {
                return this.$store.getters.shoppingCartCounter;
            }
        },
        //Computo para obtener el Monto de los elementos agregados al carrito
        getAmountPayment: {
            get: function() {
                return this.$store.getters.AmountPayment;
            }
        },
        getPaxPayment: {
            get: function() {
                return this.$store.getters.PaxPayment;
            }
        },
        Contries: {
            get: function() {
                return this.$store.getters.Contries;
            }
        },
        Currencies: {
            get: function() {
                return this.$store.getters.Currencies;
            }
        },
        Banks: {
            get: function() {
                return this.$store.getters.Banks;
            }
        },
        SafetyPayBanks: {
            get: function() {
                return this.$store.getters.SafetyPayBanks;
            }
        },
        Amount: {
            get: function() {
                return this.$store.getters.Amount;
            }
        },
        Amount: {
            get: function() {
                return this.$store.getters.Amount;
            }
        },
        IPAddress: {
            get: function() {
                return this.$store.getters.getIPAddress;
            }
        }
    },
    watch: {},
    methods: {
        comprar(producto) {},
        checkedPark(park, item) {
            this.$store.dispatch("SelectParkRoom", park);
            this.$store.dispatch("EnableAddButtomCart", item);
        },
        addRoomShoppingCart(producto) {},
        removeOfShoppingCard(producto) {
            this.$store.dispatch("removeItemShoppingCart", producto);
        },
        /*Funcion para almacenar los paquetes que el usuario comprara */
        async addToCart(item, type) {
            try {
                let ShoppingCart = this.getShoppingCart;
                // Obtenermos el primer parque ya que no encontrara mas por que es un brazalete
                // aplicamos el slice para no editar la reactivididad del elemento padre
                let Park = item.park.slice(0, 1).shift();
                // Contruimos el objeto que se almacenara y que requiere el carrito para funcionar
                let dataForSave = {
                    Code: item.code,
                    ParkID: Park.ParkID,
                    ReferenceSivexID: item.Price.Id,
                    ParkLogo: Park.parkLogo,
                    ParkName: Park.parkName,
                    TotalMedia: Park.TotalMedia,
                    Price: item.Price.NormalIndividual,
                    codeType: type
                };

                // Verificamos si existe ya almacenado este album
                if (!this.existItemInShoppingCart(ShoppingCart, dataForSave)) {
                    let ShoppingCart = this.getShoppingCart;
                    ShoppingCart.push(dataForSave);

                    /* Calling the `setShoppingCart` method of the `store.js` file. */
                    this.$store.dispatch('setShoppingCart', ShoppingCart);

                    let rulesByPark = { ParkID: Park.ParkID };
                    /* Filtering the items by ParkID and type = 1. */
                    let GetItemsByPark = this.GetTagsByPark(this.getShoppingCart, rulesByPark);

                    /* A recursive function that is calling itself until the condition is met. */
                    let getPrice = async() => {
                        let arg = {
                            ParkID: Park.ParkID,
                            PaxPayment: this.PaxShoppingCart,
                            ServiceNumber: GetItemsByPark.length,
                            SaleService: {
                                ReferenceSivexID: item.Price.Id
                            }
                        };
                        /* Calling the `get` method of the `ShoppingCartPriceData` class. */
                        let response = await ShoppingCartPriceData.get(arg);

                        return response;
                    }

                    let getNewPrice = await getPrice();

                    this.$store.dispatch('setUpdatePriceShop', getNewPrice.data);

                    // Volvemos a calcular el total cuando se agregue un elemento del carrito
                    this.sumAmount();
                }
            } catch (error) {
                
            }
        },
        GetPriceByPax(data) {
            let response = ShoppingCartPrice.get(ArgByPriceReload);
        },
        /* Filtering the items by Code | ParkID | type = 1 */
        GetTagsByPark(items, rules) {
            let getItemsByPark = this.getShoppingCart.filter(item => item.ParkID === rules.ParkID && item.codeType === 1);
            
            return getItemsByPark;
        },
        sumAmount() {
            let ShoppingCart = this.getShoppingCart;
            //Ya que agreguemos el nuevo parque a comprar calularemos nuevamente el total
            const sumAmount = ShoppingCart.map(item => item.Price).reduce((prev, curr) => prev + curr, 0);
        },
        //Funcion para remover el codigo agregado al carrito de compra
        removeItemOfShoppingCart(idx) {
            this.getShoppingCart.splice(idx, 1);
            this.$store.dispatch('setShoppingCart', this.getShoppingCart);
            // Volvemos a calcular el total cuando se quite un elemento del carrito
            this.sumAmount();
        },
        //Funcion que verifica si el codigo ya esta en la lista de los codigos agregados al carrito
        existItemInShoppingCart(Tags, album) {
            const existItem = Tags.some(tag => tag.Code === album.Code && tag.ParkID === album.ParkID);

            return existItem;
        },
        // Funcion para verificar si hay algun valor ya ingresado para ver si se actualizara el precio de los elementos
        IsPackageAdded(ParkID) {
            let PaxPayment = this.getShoppingCart;
            // 1 - Es para el tipo Brazalete | Casco | RFID
            let exist = PaxPayment.some(data => data.ParkID === ParkID && data.codeType === 1)

            return exist;
        }
    }
};